import numeral from 'numeral';
import moment from 'moment';

try {
  if (!numeral.locales['it']) {
    numeral.register('locale', 'it', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'mila',
            million: 'mil',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return 'º';
        },
        currency: {
            symbol: '€'
        }
    });
  }
  numeral.locale('it');
} catch (error) {
  console.log(error);
}


export const formatDate = function(value) {
  return moment(value).format('DD/MM/YYYY');
}

export const formatMoney = function(value) {
  return numeral(value).format('0.00 $');
}

export const formatMoneyMillis = function(value) {
  return numeral(value).format('0.0000 $');
}

export const formatWeight = function(value) {
  return numeral(value).format('0.0000');
}

export const formatNumber = function(value) {
  return numeral(value).format('0.00');
}
